<template>
  <div>
    <widget>
        <b-row>
          <b-col>
            <dl>
              <dt>Legal Name</dt>
              <dd>{{contract.legalName}}</dd>
              <dt>Agreement Type</dt>
              <dd>{{contract.contractAgreementType.name}}</dd>
              <dt>Stage</dt>
              <dd>{{contract.currentContractStage.name}}</dd>
              <dt>Status</dt>
              <dd>{{contract.currentContractStatus.name}}</dd>
            </dl>
          </b-col>
          <b-col>
            <dl>
                <dt>Date To Agency</dt>
                <dd>{{contract.dateToAgency | formatDate}}</dd>
                <dt>Dean's Signature Date</dt>
                <dd>{{contract.dateDeanSignature | formatDate}}</dd>
                <dt>Start Date</dt>
                <dd>{{contract.startDate |formatDate}} <span v-if="contract.startTerm">  ({{contract.startTerm.description}}) </span></dd>
                <dt>End Date</dt>
                <dd>{{contract.endDate | formatDate}} <span v-if="contract.endTerm">  ({{contract.endTerm.description}})  </span> </dd>
            </dl>
          </b-col>
        </b-row>
    </widget>
    
    <widget heading="Sites">
        <b-container class="clearfix row">
          <b-col>
            <table-widget :items="contract.contractSites" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
              <template slot="content">
                <b-table striped
                    :items="contract.contractSites"
                    :fields="siteFields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    @filtered="onFiltered"
                    small>
                  <template slot="name" slot-scope="data">
                    <router-link :to="{ name: 'site', params: { siteId: data.item.site.siteId } }">{{ data.item.site.name }}</router-link>
                  </template>
                  <template slot="address" slot-scope="data">
                    {{ data.item.site.streetAddress }}<br/>
                    {{ data.item.site.city }}, {{ data.item.site.state }}<br/>
                    {{ data.item.site.zip }}
                  </template>
                  <template slot="required" slot-scope="data">
                    {{!data.item.site.siteContractrequirement ? null : data.item.site.siteContractrequirement.name}}
                  </template>
                </b-table>
              </template>
            </table-widget>
          </b-col>
        </b-container>
    </widget>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      siteFields: [
        { key: "name" },
        { key: "address" },
        { key: "required", label: "Contract Required" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0
    };
  },

  components: {
    "table-widget": TableWidget
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },

  props: {
    contract: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
